import { HomeTitle } from "../components";
import { useLang } from "../context/LangProvider";
import { useWords,useTitle } from "../hooks";
import { FaLongArrowAltDown } from "react-icons/fa";
import { MdDone } from "react-icons/md";
import {
	VerticalTimeline,
	VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const Partners = () => {
	const [lang] = useLang();
	const langWords = useWords(lang);
	useTitle(langWords.partners || "");
	const colors = ["#FF6584", "#FFBA3F", "#4278DF", "#6FCF97"];

	return (
		<div className="container" style={{ marginTop: "120px" }}>
			<HomeTitle title={langWords.partnersPageTitle} center />
			<p className="text-center mt-4 max-w-2xl m-auto text-primary opacity-80">
				{langWords.partnersPageDescription}
			</p>
			<img
				src="/assets/illustrations/partners-steps.svg"
				alt="patner"
				className="mx-auto mt-10 w-64"
			/>
			<section className="mt-8">
				<VerticalTimeline>
					<VerticalTimelineElement
						className="vertical-timeline-element--work"
						contentStyle={{ background: "#fafafa", color: "#3f3f46" }}
						contentArrowStyle={{ borderRight: "7px solid  #3f3f46" }}
						iconStyle={{ background: colors[0], color: "#fff" }}
						icon={<FaLongArrowAltDown />}
					>
						<h3 className="vertical-timeline-element-title font-bold text-2xl capitalize">
							{langWords.partnersPageHowItWorks}
						</h3>
						<p className="opacity-80">{langWords.partnersPageHowItWorksMore}</p>
					</VerticalTimelineElement>
					<VerticalTimelineElement
						className="vertical-timeline-element--work"
						contentStyle={{ background: "#fafafa", color: "#3f3f46" }}
						contentArrowStyle={{ borderRight: "7px solid  #3f3f46" }}
						iconStyle={{ background: colors[1], color: "#fff" }}
						icon={<FaLongArrowAltDown />}
					>
						<h3 className="vertical-timeline-element-title font-bold text-2xl capitalize">
							{langWords.partnersPageRegister}
						</h3>
						<p className="opacity-80">{langWords.partnersPageRegisterMore}</p>
					</VerticalTimelineElement>
					<VerticalTimelineElement
						className="vertical-timeline-element--work"
						contentStyle={{ background: "#fafafa", color: "#3f3f46" }}
						contentArrowStyle={{ borderRight: "7px solid  #3f3f46" }}
						iconStyle={{ background: colors[2], color: "#fff" }}
						icon={<FaLongArrowAltDown />}
					>
						<h3 className="vertical-timeline-element-title font-bold text-2xl capitalize">
							{langWords.partnersPageRV}
						</h3>
						<p className="opacity-80">{langWords.partnersPageRVMore}</p>
					</VerticalTimelineElement>
					<VerticalTimelineElement
						className="vertical-timeline-element--work"
						contentStyle={{ background: "#fafafa", color: "#3f3f46" }}
						contentArrowStyle={{ borderRight: "7px solid  #3f3f46" }}
						iconStyle={{ background: colors[3], color: "#fff" }}
						icon={<MdDone fontSize="2rem" />}
					>
						<h3 className="vertical-timeline-element-title font-bold text-2xl capitalize">
							{langWords.partnersPageCongrats}
						</h3>
						<p className="opacity-80">{langWords.partnersPageCongratsMore}</p>
					</VerticalTimelineElement>
				</VerticalTimeline>
			</section>
		</div>
	);
};

export default Partners;
